(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/NotificationItemsContent/NotificationItemsContent.ts":
/*!******************************************************************!*\
  !*** ./src/NotificationItemsContent/NotificationItemsContent.ts ***!
  \******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   NotificationItemsContent: () => (/* binding */ NotificationItemsContent)
/* harmony export */ });
var NotificationItemsContent;
(function (NotificationItemsContent) {
    class DataController {
        constructor(p) {
            this.localization = {
                closeButtonText: "Close"
            };
            this.type = p.type;
            this.text = p.text;
            this.link = p.link;
            this.linkName = p.linkName;
            this.linkTooltip = p.linkTooltip;
            this.iconDetail = p.iconDetail;
            this.linkHandler = p.linkHandler;
            this.clickHandler = p.clickHandler;
            this.errorDetail = p.errorDetail;
            this.taskId = p.taskId;
            this.localization = p.localization || this.localization;
            this.dismissHandler = p.dismissHandler;
            this.actions = p.actions;
            this.lineClamp = p.lineClamp;
        }
    }
    NotificationItemsContent.DataController = DataController;
})(NotificationItemsContent || (NotificationItemsContent = {}));


/***/ }),

/***/ "./src/browser-notifications/BrowserNotifications.ts":
/*!***********************************************************!*\
  !*** ./src/browser-notifications/BrowserNotifications.ts ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   BrowserNotification: () => (/* binding */ BrowserNotification),
/* harmony export */   createBrowserNotifications: () => (/* binding */ createBrowserNotifications)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};

var BrowserNotification;
(function (BrowserNotification) {
    class Service {
        static get isBrowserNotificationPromiseSupported() {
            try {
                window.Notification.requestPermission().then();
                // eslint-disable-next-line sonarjs/no-ignored-exceptions
            }
            catch (e) {
                return false;
            }
            return true;
        }
        constructor(
        // Features support:
        // https://developer.mozilla.org/en-US/docs/Web/API/Notification#Browser_compatibility
        // https://developers.google.com/web/fundamentals/push-notifications/display-a-notification#visual_options
        defaultOptions) {
            this.defaultOptions = defaultOptions || {};
        }
        get isBrowserNotificationSupported() {
            return !!("Notification" in window);
        }
        get isBrowserNotificationIconSupported() {
            return this.isBrowserNotificationSupported && "icon" in window.Notification.prototype;
        }
        get isBrowserNotificationImageSupported() {
            return this.isBrowserNotificationSupported && "image" in window.Notification.prototype;
        }
        get isBrowserNotificationBadgeSupported() {
            return this.isBrowserNotificationSupported && "badge" in window.Notification.prototype;
        }
        get isPermissionGranted() {
            return window.Notification.permission === "granted";
        }
        get isPermissionDenied() {
            return window.Notification.permission === "denied";
        }
        get isPermissionUnknown() {
            return !this.isPermissionGranted && !this.isPermissionDenied;
        }
        requestNotificationUserPermission() {
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.isBrowserNotificationSupported) {
                    _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.warn("Browser notification is not supported...");
                }
                else {
                    Service.isBrowserNotificationPromiseSupported
                        ? yield window.Notification.requestPermission()
                        : yield new Promise((resolve) => window.Notification.requestPermission((permission) => resolve(permission)));
                }
            });
        }
        fire(title, 
        // https://developers.google.com/web/fundamentals/push-notifications/display-a-notification#visual_options
        options) {
            return new window.Notification(title, Object.assign(Object.assign({}, this.defaultOptions), (options || {})));
        }
    }
    BrowserNotification.Service = Service;
})(BrowserNotification || (BrowserNotification = {}));
function createBrowserNotifications(
//https://developers.google.com/web/fundamentals/push-notifications/display-a-notification#visual_options
defaultOptions) {
    return new BrowserNotification.Service(defaultOptions);
}


/***/ }),

/***/ "./src/decorators/decorator-debounce.ts":
/*!**********************************************!*\
  !*** ./src/decorators/decorator-debounce.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Debounce: () => (/* binding */ Debounce)
/* harmony export */ });
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper */ "./src/decorators/helper.ts");
/* eslint-disable @typescript-eslint/no-explicit-any */

function Debounce(ms = 250) {
    return function (target, key, descriptor) {
        let timeout;
        return (0,_helper__WEBPACK_IMPORTED_MODULE_0__.decorateFunction)({ target, key, descriptor }, function (funcOriginal, args) {
            clearTimeout(timeout);
            /* istanbul ignore next */
            timeout = window.setTimeout(() => {
                clearTimeout(timeout);
                funcOriginal.apply(this, args);
            }, ms);
        });
    };
}


/***/ }),

/***/ "./src/decorators/decorator-evt.ts":
/*!*****************************************!*\
  !*** ./src/decorators/decorator-evt.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   evt: () => (/* binding */ evt)
/* harmony export */ });
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../index */ "./src/index.ts");
/* eslint-disable @typescript-eslint/no-explicit-any */

function evt() {
    return (protoOrDescriptor, name) => {
        const descriptor = {
            get() {
                return new _index__WEBPACK_IMPORTED_MODULE_0__.Evt(this, name !== undefined ? name : protoOrDescriptor.key);
            },
            enumerable: true,
            configurable: true
        };
        if (name !== undefined) {
            // legacy TS decorator
            return Object.defineProperty(protoOrDescriptor, name, descriptor);
        }
        else {
            // TC39 Decorators proposal
            return {
                kind: "method",
                placement: "prototype",
                key: protoOrDescriptor.key,
                descriptor
            };
        }
    };
}


/***/ }),

/***/ "./src/decorators/decorator-exec.ts":
/*!******************************************!*\
  !*** ./src/decorators/decorator-exec.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Exec: () => (/* binding */ Exec)
/* harmony export */ });
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper */ "./src/decorators/helper.ts");
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/no-explicit-any */

function Exec(exec, preventDoubleRun = true) {
    return function (target, key, descriptor) {
        return (0,_helper__WEBPACK_IMPORTED_MODULE_0__.decorateFunction)({ target, key, descriptor }, function (funcOriginal, args) {
            return __awaiter(this, void 0, void 0, function* () {
                const flag = `_${key}_exec_flag`;
                if (preventDoubleRun && this[flag]) {
                    return;
                }
                const run = (isExec) => {
                    this[flag] = isExec;
                    const isFunc = typeof exec == "function";
                    if (isFunc) {
                        const f = exec;
                        f.call(this, { isExec, ctx: this });
                    }
                    else {
                        const e = exec;
                        if (isExec) {
                            if (e.before) {
                                e.before.call(this, this);
                            }
                        }
                        else {
                            if (e.after) {
                                e.after.call(this, this);
                            }
                        }
                    }
                };
                run(true);
                const result = funcOriginal.apply(this, args);
                if (result instanceof Promise) {
                    result.then(() => run(false)).catch(() => run(false));
                }
                else {
                    // eslint-disable-next-line no-console
                    console.warn("Must be async function to use [@Executing] decorator");
                    run(false);
                }
            });
        });
    };
}


/***/ }),

/***/ "./src/decorators/decorator-handle.ts":
/*!********************************************!*\
  !*** ./src/decorators/decorator-handle.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Handle: () => (/* binding */ Handle)
/* harmony export */ });
/* harmony import */ var _err_err__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../err/err */ "./src/err/err.ts");
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helper */ "./src/decorators/helper.ts");
/* eslint-disable @typescript-eslint/no-this-alias,no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};


function Handle(handlers) {
    return function (target, key, descriptor) {
        return (0,_helper__WEBPACK_IMPORTED_MODULE_1__.decorateFunction)({ target, key, descriptor }, function (funcOriginal, args, className) {
            return __awaiter(this, void 0, void 0, function* () {
                const ctx = this;
                const handleError = (error) => __awaiter(this, void 0, void 0, function* () {
                    const isErr = error.id && typeof error.id === "string" && error.isErr === "yes";
                    if (!isErr) {
                        if (typeof error == "string") {
                            error = new _err_err__WEBPACK_IMPORTED_MODULE_0__.Err.Message("system", error);
                        }
                        else if (error instanceof Error) {
                            error = new _err_err__WEBPACK_IMPORTED_MODULE_0__.Err.Message("system", error);
                        }
                        else {
                            console.warn("Err must be 'string' or 'new Error()' instance");
                            error = new _err_err__WEBPACK_IMPORTED_MODULE_0__.Err.Message("system", "");
                        }
                    }
                    const err = error;
                    err.ctx = ctx;
                    // var argsLog = args.map(a => JSON.stringify(a)).join(", ");
                    // let errLog = `Error] ${className}.${key}(${argsLog}) [${err.id}]:${err.message}`;
                    const errLog = `Error] ${className}.${key} [${err.id}]: ${err.message}`;
                    const isFunc = typeof handlers == "function";
                    if (isFunc) {
                        const f = handlers;
                        console.log(`[Handled${errLog}`);
                        const handle = f.call(ctx, err);
                        if (handle instanceof Promise) {
                            yield handle;
                        }
                    }
                    else {
                        const h = handlers;
                        if (h[err.id]) {
                            console.log(`[Handled${errLog}`);
                            const handler = h[err.id].call(ctx, err);
                            if (handler instanceof Promise) {
                                yield handler;
                            }
                        }
                        else if (h.handle) {
                            console.log(`[Handled${errLog}`);
                            const handle = h.handle.call(ctx, err);
                            if (handle instanceof Promise) {
                                yield handle;
                            }
                        }
                        else {
                            console.warn(`[Unhandled ${errLog}`);
                        }
                        if (h.fallback) {
                            const fallback = h.fallback.call(ctx, err);
                            if (fallback instanceof Promise) {
                                yield fallback;
                            }
                        }
                    }
                });
                try {
                    const result = funcOriginal.apply(ctx, args);
                    if (result instanceof Promise) {
                        // wrap promise inside another one
                        return new Promise((resolve) => {
                            result
                                .then(resolve) // success
                                // eslint-disable-next-line sonarjs/no-nested-functions
                                .catch((error) => __awaiter(this, void 0, void 0, function* () {
                                yield handleError(error);
                                resolve(undefined); // failed
                            }));
                        });
                    }
                    else {
                        return result; // success
                    }
                }
                catch (error) {
                    yield handleError(error);
                    return undefined; // failed
                }
            });
        });
    };
}


/***/ }),

/***/ "./src/decorators/decorator-once.ts":
/*!******************************************!*\
  !*** ./src/decorators/decorator-once.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Once: () => (/* binding */ Once)
/* harmony export */ });
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper */ "./src/decorators/helper.ts");
/* eslint-disable @typescript-eslint/no-explicit-any */

function Once() {
    return function (target, key, descriptor) {
        return (0,_helper__WEBPACK_IMPORTED_MODULE_0__.decorateFunction)({ target, key, descriptor }, function (funcOriginal, args) {
            const flag = `_${key}_once_flag`;
            if (this[flag]) {
                return;
            }
            this[flag] = true;
            funcOriginal.call(this, args);
        });
    };
}


/***/ }),

/***/ "./src/decorators/decorator-throttle.ts":
/*!**********************************************!*\
  !*** ./src/decorators/decorator-throttle.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Throttle: () => (/* binding */ Throttle)
/* harmony export */ });
/* harmony import */ var _helper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helper */ "./src/decorators/helper.ts");
/* eslint-disable @typescript-eslint/no-explicit-any */

function Throttle(ms = 1000 / 60) {
    return function (target, key, descriptor) {
        let lastTimeoutRef = undefined;
        let last = Date.now();
        return (0,_helper__WEBPACK_IMPORTED_MODULE_0__.decorateFunction)({ target, key, descriptor }, function (funcOriginal, args) {
            // Throttling
            const next = (...nextArgs) => {
                const now = Date.now();
                window.clearTimeout(lastTimeoutRef);
                if (!last || now - last >= ms) {
                    last = now;
                    funcOriginal.apply(this, nextArgs);
                }
                else {
                    // eslint-disable-next-line sonarjs/no-nested-functions
                    lastTimeoutRef = window.setTimeout(() => next(...nextArgs), ms - (now - last));
                }
            };
            next(...args);
        });
    };
}


/***/ }),

/***/ "./src/decorators/decorator.ts":
/*!*************************************!*\
  !*** ./src/decorators/decorator.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Decorator: () => (/* binding */ Decorator)
/* harmony export */ });
/* harmony import */ var _decorator_debounce__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./decorator-debounce */ "./src/decorators/decorator-debounce.ts");
/* harmony import */ var _decorator_evt__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./decorator-evt */ "./src/decorators/decorator-evt.ts");
/* harmony import */ var _decorator_exec__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./decorator-exec */ "./src/decorators/decorator-exec.ts");
/* harmony import */ var _decorator_handle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./decorator-handle */ "./src/decorators/decorator-handle.ts");
/* harmony import */ var _decorator_once__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./decorator-once */ "./src/decorators/decorator-once.ts");
/* harmony import */ var _decorator_throttle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./decorator-throttle */ "./src/decorators/decorator-throttle.ts");
/* eslint-disable @typescript-eslint/no-unused-vars */






var Decorator;
(function (Decorator) {
    Decorator.Debounce = _decorator_debounce__WEBPACK_IMPORTED_MODULE_0__.Debounce;
    Decorator.Evt = _decorator_evt__WEBPACK_IMPORTED_MODULE_1__.evt;
    Decorator.Exec = _decorator_exec__WEBPACK_IMPORTED_MODULE_2__.Exec;
    Decorator.Handle = _decorator_handle__WEBPACK_IMPORTED_MODULE_3__.Handle;
    Decorator.Once = _decorator_once__WEBPACK_IMPORTED_MODULE_4__.Once;
    Decorator.Throttle = _decorator_throttle__WEBPACK_IMPORTED_MODULE_5__.Throttle;
})(Decorator || (Decorator = {}));


/***/ }),

/***/ "./src/decorators/helper.ts":
/*!**********************************!*\
  !*** ./src/decorators/helper.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   decorateFunction: () => (/* binding */ decorateFunction)
/* harmony export */ });
/* eslint-disable prefer-rest-params */
/* eslint-disable @typescript-eslint/no-explicit-any */
function decorateFunction(p, funcWrap) {
    p.descriptor = p.descriptor || Object.getOwnPropertyDescriptor(p.target, p.key);
    if (typeof p.descriptor.value !== "function") {
        // eslint-disable-next-line no-console
        console.warn(p.key, "Decorator must be used on function");
        return p.descriptor;
    }
    const funcOriginal = p.descriptor.value;
    const className = p.target.constructor.name;
    p.descriptor.value = function wrap() {
        const args = [];
        for (let i = 0; i < arguments.length; i++) {
            args[i] = arguments[i];
        }
        return funcWrap.call(this, funcOriginal, args, className);
    };
    return p.descriptor;
}


/***/ }),

/***/ "./src/err/err.ts":
/*!************************!*\
  !*** ./src/err/err.ts ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Err: () => (/* binding */ Err)
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
/*
// EXAMPLE this is how to register an use new errors all over the project

import { Err } from "@uuip/unified-ui-platform-sdk";
declare module "@uuip/unified-ui-platform-sdk" {
  namespace Err {
    interface Ids {
      "Scope.file":
        | "Scope.file.functionNameOne"
        | { "Scope.file.functionNameTwo": SomeType } // Err.Details
        | "Scope.file.functionNameThree";
    }
  }
}
*/
/* eslint-disable @typescript-eslint/no-empty-interface */
var Err;
(function (Err) {
    class Message extends Error {
        constructor(id, value) {
            super();
            // Marker to distinct Err class from other errors
            this.isErr = "yes";
            this.id = id;
            this.stack = new Error().stack;
            if (typeof value == "string") {
                this.message = value;
            }
            else if (value instanceof Error) {
                this.message = value.message;
                this.name = value.name;
            }
            else {
                this.message = "";
            }
        }
    }
    Err.Message = Message;
    class Details extends Error {
        constructor(id, details) {
            super();
            // Marker to distinct Err class from other errors
            this.isErr = "yes";
            this.id = id;
            this.stack = new Error().stack;
            this.details = details;
        }
    }
    Err.Details = Details;
    // TypeScript BUG - cant use this approach yet
    // ------------------------------------------
    // export interface WithId extends Error {
    //   readonly id: Id;
    // }
    // export interface WithIdAndDetails<T extends IdsDetails> extends WithId {
    //   readonly details: IdsDetailsType[T];
    // }
    // class ErrClass<T extends IdsDetails> extends Error {
    //   readonly id: Id;
    //   readonly details: DetailsType[T];
    //   constructor(id: IdsMessage | T, value?: string | Error | DetailsType[T]) {
    //     super();
    //     this.id = id;
    //     this.stack = new Error().stack!;
    //     this.details = undefined as any;
    //     if (value === undefined) {
    //       this.message = "";
    //     } else if (typeof value == "string") {
    //       this.message = value;
    //     } else if (value instanceof Error) {
    //       this.message = value.message;
    //       this.name = value.name;
    //     } else {
    //       this.message = "{err.details}";
    //       this.details = value;
    //     }
    //   }
    //   // Marker to distinct Err class from other errors
    //   private isErr = "yes";
    // }
    // export class Create {
    // BUG is in this line
    // withId<T extends IdsDetails>(id: T, details: IdsDetailsType[T]): WithIdAndDetails<T> {
    //   return "" as any;
    // }
    // withId(id: IdsMessage): WithId;
    // withId(id: IdsMessage, message: string): WithId;
    // withId(id: IdsMessage, error: Error): WithId;
    // withId(id: any, value?: any): any {
    //   return new ErrClass(id, value);
    // }
    // }
    // export const withId = new Create().withId;
})(Err || (Err = {}));


/***/ }),

/***/ "./src/evt/evt.ts":
/*!************************!*\
  !*** ./src/evt/evt.ts ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Evt: () => (/* binding */ Evt)
/* harmony export */ });
/* eslint-disable @typescript-eslint/no-explicit-any */
class Evt {
    constructor(target, eventName) {
        this.target = target;
        this.eventName = eventName;
    }
    emit(value, options = {
        bubbles: true,
        composed: true,
        cancelable: false
    }) {
        this.target.dispatchEvent(new CustomEvent(this.eventName, Object.assign({ detail: value }, options)));
    }
}


/***/ }),

/***/ "./src/http/Http.ts":
/*!**************************!*\
  !*** ./src/http/Http.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createHttp: () => (/* binding */ createHttp)
/* harmony export */ });
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! axios */ "axios");
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! uuid */ "uuid");
/* harmony import */ var uuid__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(uuid__WEBPACK_IMPORTED_MODULE_1__);


const SENDER_TYPE = "uuip";
const VERSION = "1.0";
const VERSION_PRODUCT = "1.0";
function createHttp(accessToken) {
    const instance = axios__WEBPACK_IMPORTED_MODULE_0___default().create();
    instance.accessToken = accessToken;
    /* istanbul ignore next */
    instance.interceptors.request.use(config => {
        // auth
        if (!config.headers.Authorization && instance.accessToken) {
            config.headers.Authorization = `Bearer ${instance.accessToken}`;
        }
        // tracking
        if (!config.headers.TrackingID) {
            const id = (0,uuid__WEBPACK_IMPORTED_MODULE_1__.v1)();
            config.headers.TrackingID = `${SENDER_TYPE}_${id}_${VERSION}:${VERSION_PRODUCT}`;
        }
        // JSON as default
        if (!config.headers["Content-Type"]) {
            config.headers["Content-Type"] = "application/json";
        }
        return config;
    });
    return instance;
}


/***/ }),

/***/ "./src/i18n/i18n.ts":
/*!**************************!*\
  !*** ./src/i18n/i18n.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   I18N: () => (/* binding */ I18N)
/* harmony export */ });
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! i18next */ "i18next");
/* harmony import */ var i18next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(i18next__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var i18next_http_backend__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! i18next-http-backend */ "i18next-http-backend");
/* harmony import */ var i18next_http_backend__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(i18next_http_backend__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var i18next_browser_languagedetector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! i18next-browser-languagedetector */ "i18next-browser-languagedetector");
/* harmony import */ var i18next_browser_languagedetector__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(i18next_browser_languagedetector__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");




var I18N;
(function (I18N) {
    I18N.createService = (createServiceOptions) => {
        const i18n = i18next__WEBPACK_IMPORTED_MODULE_0___default().createInstance();
        // backend
        {
            const backend = createServiceOptions && createServiceOptions.backend ? createServiceOptions.backend : new (i18next_http_backend__WEBPACK_IMPORTED_MODULE_1___default())();
            i18n.use(backend);
        }
        // language detector
        {
            const languageDetector = createServiceOptions && createServiceOptions.languageDetector
                ? createServiceOptions.languageDetector
                : new (i18next_browser_languagedetector__WEBPACK_IMPORTED_MODULE_2___default())();
            i18n.use(languageDetector);
        }
        // logger
        if (createServiceOptions && createServiceOptions.logger) {
            i18n.use({
                log: "log" in createServiceOptions.logger ? createServiceOptions.logger.log : createServiceOptions.logger.info,
                warn: createServiceOptions.logger.warn,
                error: createServiceOptions.logger.error,
                type: "logger"
            });
        }
        return i18n;
    };
    I18N.mergeServiceInitOptions = (...initOptions) => Object.assign.call(null, {}, ...initOptions);
    I18N.createMixin = (createMixinOptions) => {
        const i18nInstance = "i18n" in createMixinOptions ? createMixinOptions.i18n : I18N.createService();
        const i18nInitOptions = "i18nInitOptions" in createMixinOptions ? createMixinOptions.i18nInitOptions : null;
        if (!i18nInitOptions) {
            _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("i18n mixin instance waiting service initialization outside...");
        }
        let isInitializing = false;
        // Initialize only if providing options
        const ensureInitialize = () => {
            if (!i18nInstance.isInitialized && !isInitializing && i18nInitOptions) {
                isInitializing = true;
                i18nInstance.init(i18nInitOptions).finally(() => (isInitializing = false));
            }
        };
        return (baseElement) => {
            return class extends baseElement {
                constructor() {
                    super(...arguments);
                    // private
                    this.onI18NInitialized = (_options) => this.requestUpdate();
                    this.onI18NLanguageChanged = (_lng) => this.requestUpdate();
                }
                // lifecycle
                connectedCallback() {
                    super.connectedCallback && super.connectedCallback();
                    i18nInstance.on("initialized", this.onI18NInitialized);
                    i18nInstance.on("languageChanged", this.onI18NLanguageChanged);
                    ensureInitialize();
                }
                disconnectedCallback() {
                    i18nInstance.off("initialized", this.onI18NInitialized);
                    i18nInstance.off("languageChanged", this.onI18NLanguageChanged);
                    super.disconnectedCallback && super.disconnectedCallback();
                }
                // Public
                t(...args) {
                    return i18nInstance.t(...args);
                }
            };
        };
    };
})(I18N || (I18N = {}));


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AssertUtils: () => (/* reexport safe */ _utils_assertUtils__WEBPACK_IMPORTED_MODULE_11__.AssertUtils),
/* harmony export */   BrowserNotification: () => (/* reexport safe */ _browser_notifications_BrowserNotifications__WEBPACK_IMPORTED_MODULE_0__.BrowserNotification),
/* harmony export */   Decorator: () => (/* reexport safe */ _decorators_decorator__WEBPACK_IMPORTED_MODULE_1__.Decorator),
/* harmony export */   Err: () => (/* reexport safe */ _err_err__WEBPACK_IMPORTED_MODULE_2__.Err),
/* harmony export */   Evt: () => (/* reexport safe */ _evt_evt__WEBPACK_IMPORTED_MODULE_3__.Evt),
/* harmony export */   I18N: () => (/* reexport safe */ _i18n_i18n__WEBPACK_IMPORTED_MODULE_5__.I18N),
/* harmony export */   Logger: () => (/* reexport safe */ _logger_Logger__WEBPACK_IMPORTED_MODULE_6__.Logger),
/* harmony export */   NotificationItemsContent: () => (/* reexport safe */ _NotificationItemsContent_NotificationItemsContent__WEBPACK_IMPORTED_MODULE_7__.NotificationItemsContent),
/* harmony export */   Notifications: () => (/* reexport safe */ _notifications_Notifications__WEBPACK_IMPORTED_MODULE_8__.Notifications),
/* harmony export */   Signal: () => (/* reexport safe */ _signal_signal__WEBPACK_IMPORTED_MODULE_9__.Signal),
/* harmony export */   clearInterval: () => (/* reexport safe */ _timerWorker__WEBPACK_IMPORTED_MODULE_10__.clearInterval),
/* harmony export */   clearTimeout: () => (/* reexport safe */ _timerWorker__WEBPACK_IMPORTED_MODULE_10__.clearTimeout),
/* harmony export */   createBrowserNotifications: () => (/* reexport safe */ _browser_notifications_BrowserNotifications__WEBPACK_IMPORTED_MODULE_0__.createBrowserNotifications),
/* harmony export */   createHttp: () => (/* reexport safe */ _http_Http__WEBPACK_IMPORTED_MODULE_4__.createHttp),
/* harmony export */   createLogger: () => (/* reexport safe */ _logger_Logger__WEBPACK_IMPORTED_MODULE_6__.createLogger),
/* harmony export */   createNotifications: () => (/* reexport safe */ _notifications_Notifications__WEBPACK_IMPORTED_MODULE_8__.createNotifications),
/* harmony export */   ensureError: () => (/* reexport safe */ _utils_errorHandling__WEBPACK_IMPORTED_MODULE_12__.ensureError),
/* harmony export */   setInterval: () => (/* reexport safe */ _timerWorker__WEBPACK_IMPORTED_MODULE_10__.setInterval),
/* harmony export */   setTimeout: () => (/* reexport safe */ _timerWorker__WEBPACK_IMPORTED_MODULE_10__.setTimeout)
/* harmony export */ });
/* harmony import */ var _browser_notifications_BrowserNotifications__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./browser-notifications/BrowserNotifications */ "./src/browser-notifications/BrowserNotifications.ts");
/* harmony import */ var _decorators_decorator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./decorators/decorator */ "./src/decorators/decorator.ts");
/* harmony import */ var _err_err__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./err/err */ "./src/err/err.ts");
/* harmony import */ var _evt_evt__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./evt/evt */ "./src/evt/evt.ts");
/* harmony import */ var _http_Http__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./http/Http */ "./src/http/Http.ts");
/* harmony import */ var _i18n_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./i18n/i18n */ "./src/i18n/i18n.ts");
/* harmony import */ var _logger_Logger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./logger/Logger */ "./src/logger/Logger.ts");
/* harmony import */ var _NotificationItemsContent_NotificationItemsContent__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./NotificationItemsContent/NotificationItemsContent */ "./src/NotificationItemsContent/NotificationItemsContent.ts");
/* harmony import */ var _notifications_Notifications__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./notifications/Notifications */ "./src/notifications/Notifications.ts");
/* harmony import */ var _signal_signal__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./signal/signal */ "./src/signal/signal.ts");
/* harmony import */ var _timerWorker__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./timerWorker */ "./src/timerWorker/index.ts");
/* harmony import */ var _utils_assertUtils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/assertUtils */ "./src/utils/assertUtils.ts");
/* harmony import */ var _utils_errorHandling__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./utils/errorHandling */ "./src/utils/errorHandling.ts");













//


/***/ }),

/***/ "./src/logger/Logger.ts":
/*!******************************!*\
  !*** ./src/logger/Logger.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Logger: () => (/* binding */ Logger),
/* harmony export */   createLogger: () => (/* binding */ createLogger),
/* harmony export */   flushLogger: () => (/* binding */ flushLogger)
/* harmony export */ });
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! event-emitter */ "event-emitter");
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(event_emitter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers/Utils */ "./src/logger/helpers/Utils.ts");
/* eslint-disable @typescript-eslint/no-explicit-any,no-console */



const ensureStringified = (...args) => args.map((a) => (typeof a === "string" ? a : JSON.stringify(a)));
var Logger;
(function (Logger) {
    Logger.MAX_LOGS_SIZE = 1048576; // 1Mb
    Logger.LS_LOGS_KEY = "uuip-client-logs";
    const OBJECT_SPLIT = "<uuip-eol>";
    const READABLE_JSON_SPACES = 2;
    const NON_ASCII_CHARS_REGEXP = /[\u0100-\uFFFF]/g; // Unicode
    const ASCII_CHAR_BYTES_SIZE = 1; // ASCII Char size = 1b
    const NON_ASCII_CHAR_BYTES_SIZE = 2; // NON-ASCII Char size = 2b
    const LOG_TIMESTAMP_FORMAT = "yyyy-LL-dd HH:mm:ss:SSS";
    Logger.defaultSaveIntervalMilliSeconds = 5000; // We only export for testing purposes
    let Level;
    (function (Level) {
        Level[Level["Trace"] = 1] = "Trace";
        Level[Level["Debug"] = 2] = "Debug";
        Level[Level["Warn"] = 3] = "Warn";
        // eslint-disable-next-line @typescript-eslint/no-shadow
        Level[Level["Error"] = 4] = "Error";
        Level[Level["Fatal"] = 5] = "Fatal";
    })(Level = Logger.Level || (Logger.Level = {}));
    class Service {
        constructor(prefix, maskKeys) {
            this.loggerEmitter = event_emitter__WEBPACK_IMPORTED_MODULE_0___default()();
            this.prefix = prefix;
            this.maskKeys = maskKeys;
        }
        log(level, ...args) {
            if (this.maskKeys && typeof this.maskKeys === "object") {
                (0,_helpers_Utils__WEBPACK_IMPORTED_MODULE_2__.mask)(args, this.maskKeys);
            }
            const _args = ensureStringified(this.prefix ? [`${this.prefix}`, ...args] : args);
            const timestamp = Date.now();
            const lts = luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromMillis(timestamp).toFormat(LOG_TIMESTAMP_FORMAT);
            switch (level) {
                case Logger.Level.Trace:
                    console.info(lts, ..._args);
                    break;
                case Logger.Level.Debug:
                    console.log(lts, ..._args);
                    break;
                case Logger.Level.Warn:
                    console.warn(lts, ..._args);
                    break;
                case Logger.Level.Error:
                case Logger.Level.Fatal:
                    console.error(lts, ..._args);
                    break;
                default: {
                    console.log(..._args);
                }
            }
            const logRecord = {
                pfx: this.prefix,
                msgs: [...args],
                ts: timestamp,
                lvl: level
            };
            this.emit("add", logRecord);
        }
        // Public Logs
        info(...args) {
            this.log(Level.Trace, ...args);
        }
        debug(...args) {
            this.log(Level.Debug, ...args);
        }
        warn(...args) {
            this.log(Level.Warn, ...args);
        }
        error(...args) {
            this.log(Level.Error, ...args);
        }
        // Events
        emit(eventName, ...args) {
            this.loggerEmitter.emit(eventName, ...args);
        }
        addEventListener(eventName, listener) {
            this.loggerEmitter.on(eventName, listener);
            // Unsubscribe
            return () => {
                this.removeEventListener(eventName, listener);
            };
        }
        removeEventListener(eventName, listener) {
            this.loggerEmitter.off(eventName, listener);
        }
    }
    Logger.Service = Service;
    class ServicesPool {
        constructor() {
            this.loggers = new Map();
            this.logsCollectionString = ""; // Store log collection by | separated objects
            this.prefixedLogsCollections = {};
            this.lastSaveTime = Date.now();
            this.config = {
                saveIntervalMilliSeconds: Logger.defaultSaveIntervalMilliSeconds
            };
            this.logRecordsSerializedLength = 0;
            this.flush = () => {
                this.save(false);
            };
            this.onLoggerAddRecord = (logRecord) => {
                this.addLogRecord(logRecord);
                this.save(true);
            };
            this.restore();
        }
        static getSerializedJsonLogRecordBytesSize(logRecordJsonStr = "") {
            const totalCount = logRecordJsonStr.length;
            if (totalCount) {
                const asciiCount = logRecordJsonStr.replace(NON_ASCII_CHARS_REGEXP, "").length;
                const nonAsciiCount = totalCount - asciiCount;
                return asciiCount * ASCII_CHAR_BYTES_SIZE + nonAsciiCount * NON_ASCII_CHAR_BYTES_SIZE;
            }
            return totalCount;
        }
        get serializedJsonLogsBytesSize() {
            const logsCount = this.logsCollectionString.split(OBJECT_SPLIT).length;
            const size = 2 * ASCII_CHAR_BYTES_SIZE + // 2 Brackets []
                this.logRecordsSerializedLength + // logsRecords strings bytes
                (logsCount - 1) * ASCII_CHAR_BYTES_SIZE; // commas , between messages strings bytes
            return size;
        }
        save(respectWriteInterval = true) {
            const now = Date.now();
            if (respectWriteInterval) {
                if (now - this.lastSaveTime < this.config.saveIntervalMilliSeconds) {
                    return;
                }
            }
            this.lastSaveTime = now;
            window.sessionStorage.setItem(Logger.LS_LOGS_KEY, this.logsCollectionString); // Write string based logs to local storage...
        }
        restore() {
            try {
                const logsCollection = window.sessionStorage.getItem(Logger.LS_LOGS_KEY) || "";
                this.logsCollectionString = logsCollection;
                this.logRecordsSerializedLength += ServicesPool.getSerializedJsonLogRecordBytesSize(this.logsCollectionString);
                // Add prefixed based object logs.
                this.restorePreFixedLogs();
            }
            catch (e) {
                console.warn("Logger failed read logs from sessionStorage: ", e);
            }
        }
        getLogObjectFromString() {
            try {
                if (this.logsCollectionString !== "") {
                    // Convert string to array of object.
                    return JSON.parse(`[${this.logsCollectionString.split(OBJECT_SPLIT).join(",")}]`);
                }
                // eslint-disable-next-line sonarjs/no-ignored-exceptions
            }
            catch (e) {
                console.log("Error parsing local storage data");
            }
            return {};
        }
        restorePreFixedLogs() {
            const logsCollectionObj = this.getLogObjectFromString();
            if (logsCollectionObj && Array.isArray(logsCollectionObj) && logsCollectionObj.length > 0) {
                logsCollectionObj.forEach((logRecord) => {
                    this.addPreFixedLogs(logRecord);
                    this.removeOversized();
                });
            }
        }
        addPreFixedLogs(logRecord) {
            this.prefixedLogsCollections[logRecord.pfx] =
                this.prefixedLogsCollections[logRecord.pfx] || new Set();
            this.prefixedLogsCollections[logRecord.pfx].add(logRecord);
        }
        removeOversized() {
            while (this.serializedJsonLogsBytesSize > Logger.MAX_LOGS_SIZE && this.logsCollectionString !== "") {
                this.removeLogRecord();
            }
        }
        removeTextFromString(_string, sIndex, _substringLength) {
            return `${_string.slice(0, sIndex)}${_string.slice(_substringLength + sIndex)}`;
        }
        addLogRecord(logRecord) {
            try {
                const response = JSON.stringify(logRecord);
                const existingLogs = this.logsCollectionString;
                this.logsCollectionString = existingLogs === null || existingLogs === void 0 ? void 0 : existingLogs.concat(`${existingLogs.trim() !== "" ? OBJECT_SPLIT : ""}${response}`);
            }
            catch (e) {
                const response = JSON.stringify(logRecord);
                this.logsCollectionString = response;
                console.warn("Logger failed read logs from sessionStorage: ", e);
            }
            this.logRecordsSerializedLength += ServicesPool.getSerializedJsonLogRecordBytesSize(JSON.stringify(logRecord));
            this.addPreFixedLogs(logRecord);
            this.removeOversized();
        }
        removeLogRecord() {
            if (this.logsCollectionString !== "") {
                // Remove the first data.
                const index = this.logsCollectionString.indexOf(OBJECT_SPLIT);
                if (index !== -1) {
                    // Remove from logsCollectionString
                    const firstLogRecord = this.logsCollectionString.substring(0, index);
                    const endIndex = index + OBJECT_SPLIT.length;
                    const updatedLogsCollectionString = this.removeTextFromString(this.logsCollectionString, 0, endIndex);
                    this.logsCollectionString = updatedLogsCollectionString;
                    this.logRecordsSerializedLength -= ServicesPool.getSerializedJsonLogRecordBytesSize(firstLogRecord);
                    try {
                        const logRecord = JSON.parse(firstLogRecord);
                        if (this.prefixedLogsCollections[logRecord.pfx]) {
                            this.prefixedLogsCollections[logRecord.pfx].forEach((collection) => {
                                if (collection.ts === logRecord.ts) {
                                    this.prefixedLogsCollections[logRecord.pfx].delete(collection);
                                }
                            });
                        }
                    }
                    catch (e) {
                        console.warn("Logger failed to read/parse the first logs from sessionStorage: ", e);
                    }
                }
            }
        }
        removePreFixedLogs(logRecords) {
            const logsCollectionObj = this.getLogObjectFromString();
            logRecords.forEach((logRecord) => {
                const idx = logsCollectionObj.findIndex((log) => log.pfx === logRecord.pfx);
                if (idx !== -1) {
                    logsCollectionObj.splice(idx, 1);
                    this.logRecordsSerializedLength -= ServicesPool.getSerializedJsonLogRecordBytesSize(JSON.stringify(logRecord));
                    if (this.prefixedLogsCollections[logRecord.pfx] &&
                        this.prefixedLogsCollections[logRecord.pfx].has(logRecord)) {
                        this.prefixedLogsCollections[logRecord.pfx].delete(logRecord);
                    }
                }
            });
            this.logsCollectionString = logsCollectionObj
                .map((logRecord) => JSON.stringify(logRecord))
                .join(OBJECT_SPLIT);
        }
        static getLogRecordReadable(logRecord) {
            if (logRecord.ts) {
                return {
                    prefix: logRecord.pfx,
                    messages: logRecord.msgs,
                    timestamp: luxon__WEBPACK_IMPORTED_MODULE_1__.DateTime.fromMillis(logRecord.ts).toFormat(LOG_TIMESTAMP_FORMAT),
                    level: Level[logRecord.lvl]
                };
            }
            return {};
        }
        static getLogsReadableJson(logs) {
            const getLogsReadableCollection = (logRecords) => logRecords.map((logRecord) => ServicesPool.getLogRecordReadable(logRecord));
            return JSON.stringify(Array.isArray(logs)
                ? getLogsReadableCollection(logs)
                : Object.keys(logs).reduce((acc, prefix) => {
                    acc[prefix] = getLogsReadableCollection(logs[prefix]);
                    return acc;
                }, {}), null, READABLE_JSON_SPACES);
        }
        static getLogsReadableText(logs) {
            const getLogsReadableCollectionStr = (logRecords) => logRecords.reduce((acc, logRecord) => {
                const _readableLogRecord = ServicesPool.getLogRecordReadable(logRecord);
                if (_readableLogRecord) {
                    acc +=
                        `${_readableLogRecord.timestamp} ` +
                            `${_readableLogRecord.prefix} ` +
                            `${_readableLogRecord.level} ` +
                            `${ensureStringified(_readableLogRecord.messages).join(" ")} ` +
                            "\r\n";
                }
                return acc;
            }, "");
            return Array.isArray(logs)
                ? getLogsReadableCollectionStr(logs)
                : Object.keys(logs).reduce((acc, prefix) => {
                    acc += `[SERVICE "${prefix}" LOGS]: `;
                    acc += getLogsReadableCollectionStr(logs[prefix]);
                    return acc;
                }, "");
        }
        static getLogsUrl(logs) {
            return `data:text/plain;charset=utf-8,${encodeURIComponent(logs)}`;
        }
        static browserDownload(url, filename) {
            try {
                if (document && document.createElement) {
                    const el = document.createElement("a");
                    el.setAttribute("href", url);
                    el.setAttribute("download", filename);
                    el.style.display = "none";
                    document.body.appendChild(el);
                    el.click();
                    document.body.removeChild(el);
                }
                else {
                    console.warn("Browser is not supported to download logs");
                }
                // eslint-disable-next-line sonarjs/no-ignored-exceptions
            }
            catch (e) {
                //
            }
        }
        // Public
        // Add logger instance
        addLogger(logger) {
            this.loggers.set(logger.prefix, logger);
            logger.removeEventListener("add", this.onLoggerAddRecord); // Just in case if trying to add manually
            logger.addEventListener("add", this.onLoggerAddRecord);
        }
        // Download URLs
        // JSON LOGS
        /**
         * e.g. for some all services in chronological order
         * [{ ... }, { ... }, ... ]
         */
        getAllLogsJsonUrl() {
            return ServicesPool.getLogsUrl(ServicesPool.getLogsReadableJson(this.getLogObjectFromString()));
        }
        /**
         * e.g.
         * {
         *   'AgentX': [{ ... }, { ... }, ... ],
         *   'agentx-mfe-wc-based': [{ ... }, { ... }, ... ]
         * }
         */
        getAllPrefixedLogsJsonUrl() {
            return ServicesPool.getLogsUrl(ServicesPool.getLogsReadableJson(this.getAllPrefixedLogsCollections()));
        }
        /**
         * e.g. for some service 'prefix' in chronological order
         * [{ ... }, { ... }, ... ]
         */
        getPrefixedLogsJsonUrl(prefix) {
            return ServicesPool.getLogsUrl(ServicesPool.getLogsReadableJson(this.getPrefixedLogsCollection(prefix)));
        }
        // TEXT LOGS
        /**
         * e.g. for some all services in chronological order
         * [SERVICE]: ..., [MESSAGES]: ...,
         * [SERVICE]: ..., [MESSAGES]: ...,
         */
        getAllLogsTextUrl() {
            return ServicesPool.getLogsUrl(ServicesPool.getLogsReadableText(this.getLogObjectFromString()));
        }
        getPrefixedLogsTextUrl(prefix) {
            return ServicesPool.getLogsUrl(ServicesPool.getLogsReadableText(this.getPrefixedLogsCollection(prefix)));
        }
        // Download Actions
        // JSON LOGS
        browserDownloadAllLogsJson() {
            ServicesPool.browserDownload(this.getAllLogsJsonUrl(), `${new Date()}_all_logs.json`);
        }
        browserDownloadAllPrefixedLogsJson() {
            ServicesPool.browserDownload(this.getAllPrefixedLogsJsonUrl(), `${new Date()}_all_prefixed_logs.json`);
        }
        browserDownloadPrefixedLogsJson(prefix) {
            ServicesPool.browserDownload(this.getPrefixedLogsJsonUrl(prefix), `${new Date()}_${prefix}_logs.json`);
        }
        // TEXT LOGS
        browserDownloadAllLogsText() {
            ServicesPool.browserDownload(this.getAllLogsTextUrl(), `${new Date()}_all_logs.log`);
        }
        browserDownloadPrefixedLogsText(prefix) {
            ServicesPool.browserDownload(this.getPrefixedLogsTextUrl(prefix), `${new Date()}_${prefix}_logs.log`);
        }
        // Just in case for cleanup all logs
        cleanupAllLogs() {
            this.logRecordsSerializedLength = 0;
            this.logsCollectionString = "";
            Object.keys(this.prefixedLogsCollections).forEach((prefix) => (this.prefixedLogsCollections[prefix] = new Set()));
            this.save(true);
        }
        cleanupPrefixedLogs(prefix) {
            const prefixedLogs = this.getPrefixedLogsCollection(prefix);
            this.removePreFixedLogs(prefixedLogs);
            this.prefixedLogsCollections[prefix] = new Set();
            this.save(true);
        }
        getAllPrefixedLogsCollections() {
            return Object.keys(this.prefixedLogsCollections).reduce((acc, prefix) => {
                acc[prefix] = this.getPrefixedLogsCollection(prefix);
                return acc;
            }, {});
        }
        // Prefixed Logs public collection
        getPrefixedLogsCollection(prefix) {
            return Array.from(this.prefixedLogsCollections[prefix] || new Set());
        }
    }
    Logger.ServicesPool = ServicesPool;
    Logger.POOL = new Logger.ServicesPool();
})(Logger || (Logger = {}));
function createLogger(prefix, maskKeys) {
    const _logger = new Logger.Service(prefix, maskKeys);
    Logger.POOL.addLogger(_logger);
    return _logger;
}
function flushLogger() {
    Logger.POOL.flush();
}


/***/ }),

/***/ "./src/logger/helpers/Utils.ts":
/*!*************************************!*\
  !*** ./src/logger/helpers/Utils.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MASK_VALUE: () => (/* binding */ MASK_VALUE),
/* harmony export */   mask: () => (/* binding */ mask)
/* harmony export */ });
const MASK_VALUE = "*********";
const VALUE_KEY = "value";
const NAME_KEY = "name";
class MaskLogs {
    constructor(maskKeys) {
        this.maskKeys = maskKeys;
    }
    tryJSONParse(str) {
        try {
            return JSON.parse(str);
            // eslint-disable-next-line sonarjs/no-ignored-exceptions
        }
        catch (e) {
            return undefined;
        }
    }
    copiedObj(data) {
        try {
            return JSON.parse(JSON.stringify(data));
            // eslint-disable-next-line sonarjs/no-ignored-exceptions
        }
        catch (e) {
            return data;
        }
    }
    maskObjectProperty(obj) {
        const copyObj = obj;
        Object.keys(obj).forEach((key) => {
            if (typeof obj[key] == "object" && obj[key] !== null) {
                this.maskObjectProperty(obj[key]);
            }
            else {
                copyObj[key] = MASK_VALUE;
            }
        });
    }
    maskLogData(obj) {
        Object.keys(obj).forEach((key) => {
            if (typeof obj[key] == "object" && obj[key] !== null) {
                if (this.maskKeys[key]) {
                    this.maskObjectProperty(obj[key]);
                }
                else {
                    this.maskLogData(obj[key]);
                }
            }
            else if ((this.maskKeys[key] && typeof obj[key] === "string") ||
                (key === VALUE_KEY && this.maskKeys[obj[NAME_KEY]])) {
                obj[key] = MASK_VALUE;
            }
        });
    }
    maskPIIInformation(_args) {
        const eventData = _args[_args.length - 1];
        const msgObj = typeof eventData === "string" ? this.tryJSONParse(eventData) : this.copiedObj(eventData);
        if (msgObj && typeof msgObj === "object") {
            this.maskLogData(msgObj);
            _args.splice(_args.length - 1, 1, msgObj);
        }
    }
}
const mask = (_args, maskKeys) => {
    const log = new MaskLogs(maskKeys);
    log.maskPIIInformation(_args);
};


/***/ }),

/***/ "./src/notifications/Notifications.ts":
/*!********************************************!*\
  !*** ./src/notifications/Notifications.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Notifications: () => (/* binding */ Notifications),
/* harmony export */   createNotifications: () => (/* binding */ createNotifications)
/* harmony export */ });
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! event-emitter */ "event-emitter");
/* harmony import */ var event_emitter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(event_emitter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! event-emitter/all-off */ "event-emitter/all-off");
/* harmony import */ var event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! luxon */ "luxon");
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(luxon__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");




/* Notifications principal flow:

// SILENT:
// add => pended => deactivate => remove

// ACKNOWLEDGE:
// add => pended => activate => deactivate => remove

// AUTODISMISS:
// add => pended => activate
//        pended <= activate                         ( makes silent )
//        pended ============> deactivate => remove

*/
var Notifications;
(function (Notifications) {
    let ItemMeta;
    (function (ItemMeta) {
        let Type;
        (function (Type) {
            Type["Info"] = "info";
            Type["Warn"] = "warn";
            // eslint-disable-next-line @typescript-eslint/no-shadow
            Type["Error"] = "error";
            Type["Success"] = "success";
            Type["Chat"] = "chat";
            Type["Default"] = "default";
        })(Type = ItemMeta.Type || (ItemMeta.Type = {}));
        ItemMeta.TYPES = Object.values(Type);
        let Mode;
        (function (Mode) {
            // Increasing counter - but not pop-up
            Mode["Silent"] = "silent";
            // Increasing counter + popup (then auto hide on timeout or user-click-read)
            Mode["AutoDismiss"] = "autodismiss";
            // Increasing counter + display on user area until user close
            Mode["Acknowledge"] = "acknowledge";
        })(Mode = ItemMeta.Mode || (ItemMeta.Mode = {}));
        ItemMeta.MODES = Object.values(Mode);
        let Status;
        (function (Status) {
            Status["Added"] = "added";
            Status["Pended"] = "pended";
            Status["Activated"] = "activated";
            Status["Deactivated"] = "deactivated";
            Status["Removed"] = "removed";
        })(Status = ItemMeta.Status || (ItemMeta.Status = {}));
        ItemMeta.StatusWeight = {
            [Status.Added]: 0,
            [Status.Pended]: 1,
            [Status.Activated]: 2,
            [Status.Deactivated]: 3,
            [Status.Removed]: 4
        };
        ItemMeta.STATUSES = Object.values(Status);
        let AddEventReason;
        (function (AddEventReason) {
            AddEventReason["User"] = "user_add"; // one way to add
        })(AddEventReason = ItemMeta.AddEventReason || (ItemMeta.AddEventReason = {}));
        let PendingEventReason;
        (function (PendingEventReason) {
            PendingEventReason["ServiceAutoPropagate"] = "service_auto_propagate_pending";
            PendingEventReason["ServiceAutoDismiss"] = "service_autodismiss_pending";
            PendingEventReason["UserSilent"] = "user_silent_pending";
        })(PendingEventReason = ItemMeta.PendingEventReason || (ItemMeta.PendingEventReason = {}));
        let ActivateEventReason;
        (function (ActivateEventReason) {
            ActivateEventReason["ServiceAutoPropagate"] = "service_auto_propagate_activate";
        })(ActivateEventReason = ItemMeta.ActivateEventReason || (ItemMeta.ActivateEventReason = {}));
        let DeactivateEventReason;
        (function (DeactivateEventReason) {
            DeactivateEventReason["UserNegative"] = "user_negative_deactivate";
            DeactivateEventReason["UserPositive"] = "user_positive_deactivate";
            DeactivateEventReason["UserNeutral"] = "user_neutral_deactivate"; // like "snooze" or "close" or ..
        })(DeactivateEventReason = ItemMeta.DeactivateEventReason || (ItemMeta.DeactivateEventReason = {}));
        let RemoveEventReason;
        (function (RemoveEventReason) {
            RemoveEventReason["User"] = "user_remove"; // one way to remove
        })(RemoveEventReason = ItemMeta.RemoveEventReason || (ItemMeta.RemoveEventReason = {}));
    })(ItemMeta = Notifications.ItemMeta || (Notifications.ItemMeta = {}));
    let ServiceMeta;
    (function (ServiceMeta) {
        ServiceMeta.STATUS_EVENTS = ["add", "pending", "activate", "deactivate", "remove"];
        ServiceMeta.STATUS_EVENT_MAP = {
            add: ItemMeta.Status.Added,
            pending: ItemMeta.Status.Pended,
            activate: ItemMeta.Status.Activated,
            deactivate: ItemMeta.Status.Deactivated,
            remove: ItemMeta.Status.Removed
        };
        ServiceMeta.DISABLED_ITEM_MODE = {
            [ItemMeta.Mode.Silent]: false,
            [ItemMeta.Mode.AutoDismiss]: false,
            [ItemMeta.Mode.Acknowledge]: false
        };
        ServiceMeta.ACTIVATED_ITEM_MODE_LIMIT = {
            [ItemMeta.Mode.Silent]: 0,
            [ItemMeta.Mode.AutoDismiss]: 10,
            [ItemMeta.Mode.Acknowledge]: 1 // Not updating (always 1 modal)
        };
        ServiceMeta.AUTO_DISMISS_TIMEOUT = 5000;
    })(ServiceMeta = Notifications.ServiceMeta || (Notifications.ServiceMeta = {}));
    //////////////////////////////////////////////////////////////////////////////////////
    // Service <<< --- >>> Item communication Adapter
    class ServiceHubAdapter {
        constructor() {
            this.hubEmitter = event_emitter__WEBPACK_IMPORTED_MODULE_0___default()();
        }
        // Emitter Hub Private - with items communication
        emit(eventName, ...args) {
            this.hubEmitter.emit(eventName, ...args);
        }
        addEventListener(eventName, listener) {
            this.hubEmitter.on(eventName, listener);
        }
        addOnceEventListener(eventName, listener) {
            this.hubEmitter.once(eventName, listener);
        }
        removeEventListener(eventName, listener) {
            this.hubEmitter.off(eventName, listener);
        }
        removeAllEventListeners() {
            event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1___default()(this.hubEmitter);
        }
    }
    //////////////////////////////////////////////////////////////////////////////////////
    class Item {
        get status() {
            return this._status;
        }
        get reason() {
            // Status reason
            return this._reason;
        }
        get mode() {
            return this._mode;
        }
        validateAuxOptions(options) {
            let opts = {};
            if (options && options.AUTO_DISMISS_TIMEOUT !== undefined && this.mode === ItemMeta.Mode.AutoDismiss) {
                opts = Object.assign(Object.assign({}, opts), { AUTO_DISMISS_TIMEOUT: options.AUTO_DISMISS_TIMEOUT });
            }
            return opts;
        }
        constructor(raw, serviceHubAdapter) {
            this._serviceHubSubscriptions = [];
            this._itemEmitter = event_emitter__WEBPACK_IMPORTED_MODULE_0___default()();
            const { type, mode, title, data, timestamp } = raw.data;
            this.type = type;
            this.title = title;
            this.data = data;
            // Mode External read-only
            this._mode = mode;
            this.timestamp = timestamp || new Date().toISOString();
            this.datetime = luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.fromISO(this.timestamp).toLocaleString(luxon__WEBPACK_IMPORTED_MODULE_2__.DateTime.DATETIME_SHORT_WITH_SECONDS);
            // Aux options
            this.options = Object.freeze(this.validateAuxOptions(raw.options || {}));
            // Aux Injected Service emitter
            if (serviceHubAdapter) {
                this._serviceHubAdapter = serviceHubAdapter;
                this._status = ItemMeta.Status.Added;
                this._reason = ItemMeta.AddEventReason.User;
                this.bindItemHubListeners();
            }
        }
        bindItemHubListeners() {
            if (this._serviceHubAdapter) {
                // Status update
                {
                    const listener = (notificationsMap, status, reason) => {
                        if (this.timestamp in notificationsMap) {
                            //
                            // Update self status
                            this._status = status;
                            this._reason = reason;
                            //
                            // Unbind all events on remove
                            if (status === ItemMeta.Status.Removed) {
                                // Cleanup hub listeners
                                this.unbindItemHubListeners();
                                // Cleanup self listeners
                                this.removeAllEventListeners();
                            }
                            //
                            // Propagate per-item listeners update for user
                            this.emit("statusUpdate", status, reason);
                        }
                    };
                    this._serviceHubAdapter.addEventListener("statusServiceUpdateResponse", listener);
                    // Unsubscribe
                    const unsubscribe = () => {
                        var _a;
                        (_a = this._serviceHubAdapter) === null || _a === void 0 ? void 0 : _a.removeEventListener("statusServiceUpdateResponse", listener);
                    };
                    this._serviceHubSubscriptions.push(unsubscribe);
                }
                // Mode update
                {
                    const listener = (notificationsMap, mode) => {
                        if (this.timestamp in notificationsMap) {
                            //
                            // Update self mode
                            this._mode = mode;
                            // Propagate per-item listeners update for user
                            this.emit("modeUpdate", mode);
                        }
                    };
                    this._serviceHubAdapter.addEventListener("modeStatusUpdateResponse", listener);
                    // Unsubscribe
                    const unsubscribe = () => {
                        var _a;
                        (_a = this._serviceHubAdapter) === null || _a === void 0 ? void 0 : _a.removeEventListener("modeStatusUpdateResponse", listener);
                    };
                    this._serviceHubSubscriptions.push(unsubscribe);
                }
            }
        }
        /* istanbul ignore next */
        unbindItemHubListeners() {
            if (this._serviceHubSubscriptions) {
                this._serviceHubSubscriptions.forEach((u) => u());
                this._serviceHubSubscriptions.length = 0;
            }
        }
        // User allowed action
        // Make deactivated on pended || activated
        deactivate(reason) {
            //this firing to service hub
            if (this._status && ItemMeta.StatusWeight[this._status] < ItemMeta.StatusWeight[ItemMeta.Status.Deactivated]) {
                if (this._serviceHubAdapter) {
                    this._serviceHubAdapter.emit("statusServiceUpdateRequest", this, ItemMeta.Status.Deactivated, reason);
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Service hub adapter is not initialized for this notification item instance: ", this);
                }
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn(`Notification should have "${ItemMeta.Status.Pended}" or "${ItemMeta.Status.Activated}" status ` +
                    `to be able change status to "${ItemMeta.Status.Deactivated}".` +
                    `Current notification status is "${this._status}". Ignoring this change`);
            }
        }
        // Make notification silent & pended (on activated)
        /* istanbul ignore next */
        pending() {
            if (this._status === ItemMeta.Status.Activated || this.mode !== ItemMeta.Mode.Silent) {
                if (this._serviceHubAdapter) {
                    this._serviceHubAdapter.emit("statusServiceUpdateRequest", this, ItemMeta.Status.Pended, ItemMeta.PendingEventReason.UserSilent);
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn("Service hub adapter is not initialized for this notification item instance: ", this);
                }
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn(`Notification should have "${ItemMeta.Status.Activated}" status or not "${ItemMeta.Mode.Silent}" mode, ` +
                    `to be able change status to "${ItemMeta.Status.Pended}" and mode to "${ItemMeta.Mode.Silent}".` +
                    `Current notification status is "${this._status}" and mode is "${this.mode}". Ignoring this change`);
            }
        }
        // Events
        // Emitter Item Private
        emit(eventName, ...args) {
            this._itemEmitter.emit(eventName, ...args);
        }
        addEventListener(eventName, listener) {
            this._itemEmitter.on(eventName, listener);
        }
        addOnceEventListener(eventName, listener) {
            this._itemEmitter.once(eventName, listener);
        }
        removeEventListener(eventName, listener) {
            this._itemEmitter.off(eventName, listener);
        }
        removeAllEventListeners() {
            event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1___default()(this._itemEmitter);
        }
    }
    Notifications.Item = Item;
    //////////////////////////////////////////////////////////////////////////////////////
    const addToCollection = (collection, items, sortFn = () => 0) => [...collection, ...items].sort(sortFn);
    const removeFromCollection = (collection, items) => collection.reduce((acc, item) => {
        if (items.indexOf(item) === -1) {
            acc.push(item);
        }
        return acc;
    }, []);
    class Service {
        constructor() {
            this.emitter = event_emitter__WEBPACK_IMPORTED_MODULE_0___default()();
            this.map = {};
            this.status = Service.createStatus();
            this.serviceConfig = {
                DISABLED_ITEM_MODE: Object.assign({}, ServiceMeta.DISABLED_ITEM_MODE),
                ACTIVATED_ITEM_MODE_LIMIT: Object.assign({}, ServiceMeta.ACTIVATED_ITEM_MODE_LIMIT),
                AUTO_DISMISS_TIMEOUT: ServiceMeta.AUTO_DISMISS_TIMEOUT
            };
            //auto-timers
            this.activeAutoDismissTimeoutRefs = {};
            /////// Items hub emitter
            this.serviceHubAdapter = new ServiceHubAdapter();
            this.bindServiceHubEvents();
        }
        static mergeConfig(target, ...sources) {
            if (!sources.length) {
                return target;
            }
            const source = sources.shift();
            const isObj = (obj) => obj && typeof obj === "object" && !Array.isArray(obj);
            if (isObj(target) && isObj(source)) {
                for (const key in source) {
                    if (isObj(source[key])) {
                        if (!target[key]) {
                            Object.assign(target, { [key]: {} });
                        }
                        this.mergeConfig(target[key], source[key]);
                    }
                    else {
                        Object.assign(target, { [key]: source[key] });
                    }
                }
            }
            return this.mergeConfig(target, ...sources);
        }
        static createStatus() {
            return {
                // add => pended => activate => deactivate => (optional remove)
                /**
                 * Full-view of all possible notifications that ever received & not removed
                 * added count  = pended count + activated count + deactivated count
                 */
                [ItemMeta.Status.Added]: this.createStatusHolderCollection(),
                /**
                 * Received and not on screen yet (like another modal in progress)
                 */
                [ItemMeta.Status.Pended]: this.createStatusHolderCollection(),
                /**
                 * Received and on-screen now
                 */
                [ItemMeta.Status.Activated]: this.createStatusHolderCollection(),
                /**
                 * Received and acknowledged | seen by user
                 */
                [ItemMeta.Status.Deactivated]: this.createStatusHolderCollection(),
                /**
                 * Removed from events-tracking
                 */
                [ItemMeta.Status.Removed]: this.createStatusHolderCollection()
            };
        }
        static createStatusHolderCollection() {
            return Object.assign([], Object.assign(Object.assign({ ids: [] }, this.createStatusHolderSubCollections(ItemMeta.MODES)), this.createStatusHolderSubCollections(ItemMeta.TYPES)));
        }
        static createStatusHolderSubCollections(keys) {
            return Object.assign({}, keys.reduce((acc, k) => {
                acc[k] = [];
                return acc;
            }, {}));
        }
        // Sorted collections
        updateNotificationsCollections() {
            const status = Service.createStatus();
            this.status.added.ids.forEach((id) => {
                const n = this.map[id];
                ItemMeta.STATUSES.forEach((key) => {
                    if (this.status[key].ids.indexOf(n.timestamp) !== -1) {
                        status[key].push(n);
                        status[key].ids.push(id);
                        status[key][n.mode].push(n);
                        status[key][n.type].push(n);
                    }
                });
            });
            this.status = status;
        }
        setAutoDismiss(notification, onAutoDismiss = () => {
            return;
        }) {
            const _notifications = this.prepareUpdateNotifications(notification);
            _notifications.forEach((n) => {
                var _a;
                if (n.mode === ItemMeta.Mode.AutoDismiss) {
                    const onTimeout = () => onAutoDismiss(n);
                    this.activeAutoDismissTimeoutRefs[n.timestamp] = window.setTimeout(onTimeout, (_a = n.options.AUTO_DISMISS_TIMEOUT) !== null && _a !== void 0 ? _a : this.serviceConfig.AUTO_DISMISS_TIMEOUT);
                }
            });
        }
        removeAutoDismiss(notification, offAutoDismiss = () => {
            return;
        }) {
            const _notifications = this.prepareUpdateNotifications(notification);
            _notifications.forEach((n) => {
                if (n.timestamp in this.activeAutoDismissTimeoutRefs) {
                    offAutoDismiss(n);
                    window.clearTimeout(this.activeAutoDismissTimeoutRefs[n.timestamp]);
                    delete this.activeAutoDismissTimeoutRefs[n.timestamp];
                }
            });
        }
        update(eventName, eventReason, notification) {
            const notifications = !Array.isArray(notification) ? [notification] : notification;
            if (notifications.length) {
                const timestamps = notifications.map((n) => n.timestamp);
                switch (eventName) {
                    case "add": {
                        notifications.forEach((n) => (this.map[n.timestamp] = n));
                        this.status.added.ids = addToCollection(this.status.added.ids, timestamps, Service.sortTimestampsFn);
                        break;
                    }
                    case "pending": {
                        this.status.pended.ids = addToCollection(this.status.pended.ids, timestamps, Service.sortTimestampsFn);
                        this.status.activated.ids = removeFromCollection(this.status.activated.ids, timestamps);
                        this.status.deactivated.ids = removeFromCollection(this.status.deactivated.ids, timestamps);
                        break;
                    }
                    case "activate": {
                        this.status.pended.ids = removeFromCollection(this.status.pended.ids, timestamps);
                        this.status.activated.ids = addToCollection(this.status.activated.ids, timestamps, Service.sortTimestampsFn);
                        this.status.deactivated.ids = removeFromCollection(this.status.deactivated.ids, timestamps);
                        break;
                    }
                    case "deactivate": {
                        this.status.pended.ids = removeFromCollection(this.status.pended.ids, timestamps);
                        this.status.activated.ids = removeFromCollection(this.status.activated.ids, timestamps);
                        this.status.deactivated.ids = addToCollection(this.status.deactivated.ids, timestamps, Service.sortTimestampsFn);
                        break;
                    }
                    /* istanbul ignore next */
                    case "remove": {
                        this.status.pended.ids = removeFromCollection(this.status.pended.ids, timestamps);
                        this.status.activated.ids = removeFromCollection(this.status.activated.ids, timestamps);
                        this.status.deactivated.ids = removeFromCollection(this.status.deactivated.ids, timestamps);
                        this.status.added.ids = removeFromCollection(this.status.added.ids, timestamps);
                        this.status.removed.ids = addToCollection(this.status.removed.ids, timestamps, Service.sortTimestampsFn);
                        timestamps.forEach((id) => delete this.map[id]);
                        break;
                    }
                    default: {
                        break;
                    }
                }
                this.updateNotificationsCollections();
                this.emit(eventName, notifications, eventReason);
                this.propagate(eventName, eventReason, notifications);
            }
        }
        propagate(eventName, eventReason, notification) {
            const notifications = !Array.isArray(notification) ? [notification] : notification;
            if (notifications.length) {
                switch (eventName) {
                    case "add": {
                        // Propagate to pended
                        this.update("pending", ItemMeta.PendingEventReason.ServiceAutoPropagate, notifications);
                        break;
                    }
                    case "pending":
                    case "deactivate": {
                        notifications.forEach((n) => {
                            // Removing auto timers (when moving activate => pended)
                            this.removeAutoDismiss(n);
                        });
                        // Propagate to active in case of lower the limit
                        this.update("activate", ItemMeta.ActivateEventReason.ServiceAutoPropagate, 
                        //this.prepareActiveCandidatesNotifications(notifications)
                        this.prepareActiveCandidatesNotifications(this.status.pended));
                        break;
                    }
                    case "activate": {
                        notifications.forEach((n) => {
                            // Setting auto timers
                            this.setAutoDismiss(n, (_n) => {
                                // Doublecheck that mode STILL autodismiss, because it may change to silent
                                if (_n.mode === ItemMeta.Mode.AutoDismiss) {
                                    //this.update("deactivate", ItemMeta.DeactivateEventReason.ServiceAutoNegative, _n);
                                    //this.pending(_n, ItemMeta.PendingEventReason.ServiceAutoDismiss);
                                    this.serviceHubAdapter.emit("statusServiceUpdateRequest", _n, ItemMeta.Status.Pended, ItemMeta.PendingEventReason.ServiceAutoDismiss);
                                }
                            });
                        });
                        break;
                    }
                    case "remove": {
                        // Cleanup active timers and propagate new actives
                        this.update("deactivate", ItemMeta.DeactivateEventReason.UserNegative, notifications);
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        }
        prepareAddNotifications(raw) {
            const modesAllowedMessage = Object.keys(this.serviceConfig.DISABLED_ITEM_MODE)
                .reduce((acc, key) => {
                if (!this.serviceConfig.DISABLED_ITEM_MODE[key]) {
                    acc.push(key);
                }
                return acc;
            }, [])
                .map((key) => `"${key}"`)
                .join(", ");
            return (!Array.isArray(raw) ? [raw] : raw)
                .filter((r) => {
                // Check for disabled mode
                const isModeDisabled = this.serviceConfig.DISABLED_ITEM_MODE[r.data.mode];
                if (isModeDisabled) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(`Trying to .add(...) notification mode "${r.data.mode}" ` +
                        `that is disabled in this notifications service instance by configuration.` +
                        `Current configuration is: "${JSON.stringify(this.config)}"` +
                        `Only ${modesAllowedMessage} allowed. Ignoring .add(${JSON.stringify(r)}) notification...`);
                    return false;
                }
                return true;
            })
                .map((r) => {
                return new Notifications.Item(r, this.serviceHubAdapter);
            });
        }
        prepareUpdateNotifications(notification) {
            return (!Array.isArray(notification) ? [notification] : notification).reduce((acc, n) => {
                if (n.timestamp in this.map) {
                    acc.push(n);
                }
                else {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.error(`Trying to handle untracked notification. Call .add(...) first...`, JSON.stringify(n));
                }
                return acc;
            }, []);
        }
        prepareActiveCandidatesNotifications(notification) {
            const modes = (!Array.isArray(notification) ? [notification] : notification).reduce((acc, n) => {
                if (this.status.activated[n.mode].length + acc[n.mode].length <
                    this.serviceConfig.ACTIVATED_ITEM_MODE_LIMIT[n.mode]) {
                    acc[n.mode].push(n);
                }
                return acc;
            }, Service.createStatusHolderSubCollections(ItemMeta.MODES));
            return Object.values(modes).reduce((acc, list) => {
                return acc.concat(list);
            }, []);
        }
        static sortByTimestampsFn(n1, n2) {
            return Service.sortTimestampsFn(n1.timestamp, n2.timestamp);
        }
        // public getters
        get added() {
            return this.status.added;
        }
        get pended() {
            return this.status.pended;
        }
        get activated() {
            return this.status.activated;
        }
        get deactivated() {
            return this.status.deactivated;
        }
        // public methods
        getNotificationStatus(notification) {
            return Object.keys(this.status)
                .filter((s) => s !== ItemMeta.Status.Added)
                .find((statusKey) => {
                return this.status[statusKey].ids.indexOf(notification.timestamp) !== -1;
            });
        }
        //
        get config() {
            return Object.freeze(this.serviceConfig);
        }
        static validateUpdateConfig(config) {
            const _config = config;
            // In case of user makes ts-ignore and tries to hack config max
            if (_config.ACTIVATED_ITEM_MODE_LIMIT &&
                _config.ACTIVATED_ITEM_MODE_LIMIT.acknowledge > ServiceMeta.ACTIVATED_ITEM_MODE_LIMIT.acknowledge) {
                throw new Error(`
          Max ${ItemMeta.Mode.Acknowledge} limit is ${ServiceMeta.ACTIVATED_ITEM_MODE_LIMIT.acknowledge}
        `);
            }
            if (_config.DISABLED_ITEM_MODE) {
                if (!Object.keys(_config.DISABLED_ITEM_MODE).reduce((acc, key) => {
                    if (_config.DISABLED_ITEM_MODE[key]) {
                        acc++;
                    }
                    return acc;
                }, 0)) {
                    throw new Error(`At least one notifications mode should be allowed in service instance`);
                }
                Object.keys(_config.ACTIVATED_ITEM_MODE_LIMIT).forEach((key) => {
                    if (key in _config.DISABLED_ITEM_MODE && _config.DISABLED_ITEM_MODE[key]) {
                        _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn(`Changing configuration limit count for mode "${key}" won't have any effect, ` +
                            `because this mode is disabled in notifications service instance`);
                    }
                });
                if ("AUTO_DISMISS_TIMEOUT" in _config && _config.DISABLED_ITEM_MODE[ItemMeta.Mode.AutoDismiss]) {
                    _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.warn(`Changing "AUTO_DISMISS_TIMEOUT" configuration option won't have any effect,` +
                        `because "${ItemMeta.Mode.AutoDismiss}" mode is disabled in notifications service instance`);
                }
            }
            return true;
        }
        updateConfig(config) {
            if (Service.validateUpdateConfig(config)) {
                this.serviceConfig = Service.mergeConfig({}, this.serviceConfig, config);
                _sdk__WEBPACK_IMPORTED_MODULE_3__.logger.info("Updated notifications service configuration: ", this.config);
            }
        }
        add(raw) {
            const addedNotifications = this.prepareAddNotifications(raw);
            this.update("add", ItemMeta.AddEventReason.User, addedNotifications);
            return addedNotifications;
        }
        pending(notification) {
            const pendedNotifications = this.prepareUpdateNotifications(notification);
            this.serviceHubAdapter.emit("statusServiceUpdateRequest", pendedNotifications, ItemMeta.Status.Pended, ItemMeta.PendingEventReason.UserSilent);
            return pendedNotifications;
        }
        deactivate(notification, reason) {
            const deactivatedNotifications = this.prepareUpdateNotifications(notification);
            this.serviceHubAdapter.emit("statusServiceUpdateRequest", deactivatedNotifications, ItemMeta.Status.Deactivated, reason);
            return deactivatedNotifications;
        }
        remove(notification) {
            const removedNotifications = this.prepareUpdateNotifications(notification);
            this.serviceHubAdapter.emit("statusServiceUpdateRequest", removedNotifications, ItemMeta.Status.Removed, ItemMeta.RemoveEventReason.User);
            return removedNotifications;
        }
        pendingAllActivated() {
            return this.pending(this.status.activated);
        }
        pendingAll() {
            return this.pending([...this.status.pended, ...this.status.activated]);
        }
        deactivateAllActivated(reason) {
            return this.deactivate(this.status.activated, reason);
        }
        deactivateAll(reason) {
            return this.deactivate([...this.status.pended, ...this.status.activated], reason);
        }
        removeAllDeactivated() {
            return this.remove(this.status.deactivated);
        }
        removeAll() {
            return this.remove(this.status.added);
        }
        // Emitter Public
        addEventListener(eventName, listener) {
            this.emitter.on(eventName, listener);
        }
        removeEventListener(eventName, listener) {
            this.emitter.off(eventName, listener);
        }
        addOnceEventListener(eventName, listener) {
            this.emitter.once(eventName, listener);
        }
        removeAllEventListeners() {
            event_emitter_all_off__WEBPACK_IMPORTED_MODULE_1___default()(this.emitter);
        }
        // Emitter Private - internal service
        emit(eventName, ...args) {
            this.emitter.emit(eventName, ...args);
        }
        //Events request that firing from notifications items
        bindServiceHubEvents() {
            // Consult (from items)
            this.serviceHubAdapter.addEventListener("statusServiceUpdateRequest", (notification, status, reason) => {
                // Make Array
                const _notifications = Array.isArray(notification) ? notification : [notification];
                //
                const _statusMap = _notifications.reduce((acc, n) => {
                    acc[n.timestamp] = this.getNotificationStatus(n);
                    return acc;
                }, {});
                // PENDING CASE (activated => pended (silent))
                {
                    const _notificationsPending = _notifications.filter((n) => {
                        const _status = _statusMap[n.timestamp];
                        return (
                        // Item Should be activated or NOT silent
                        (_status === ItemMeta.Status.Activated || n.mode !== ItemMeta.Mode.Silent) &&
                            status === ItemMeta.Status.Pended);
                    });
                    // Making silent
                    {
                        const _notificationsPendingSilent = _notificationsPending.filter((n) => n.mode !== ItemMeta.Mode.Silent);
                        if (_notificationsPendingSilent.length) {
                            this.serviceHubAdapter.emit("modeStatusUpdateResponse", _notificationsPendingSilent.reduce((acc, _n) => {
                                acc[_n.timestamp] = _n;
                                return acc;
                            }, {}), ItemMeta.Mode.Silent);
                        }
                    }
                    // All changed to silent
                    if (_notificationsPending.length) {
                        // Self-service & outer
                        this.update("pending", reason, _notificationsPending);
                    }
                }
                // DEACTIVATE CASE ( pended || activated => deactivated)
                {
                    const _notificationsDeactivate = _notifications.filter((n) => {
                        const _status = _statusMap[n.timestamp];
                        return ((_status === ItemMeta.Status.Pended || _status === ItemMeta.Status.Activated) &&
                            status === ItemMeta.Status.Deactivated);
                    });
                    if (_notificationsDeactivate.length) {
                        // Self-service & outer
                        this.update("deactivate", reason, _notificationsDeactivate);
                    }
                }
                // REMOVED CASE (pended || activated || deactivated => removed )
                {
                    const _notificationsRemove = _notifications.filter((n) => {
                        const _status = _statusMap[n.timestamp];
                        return ((_status === ItemMeta.Status.Pended ||
                            _status === ItemMeta.Status.Activated ||
                            _status === ItemMeta.Status.Deactivated) &&
                            status === ItemMeta.Status.Removed);
                    });
                    if (_notificationsRemove.length) {
                        // Self-service & outer
                        this.update("remove", reason, notification);
                    }
                }
            });
            // Execute (from service) to notifications
            ServiceMeta.STATUS_EVENTS.forEach((eventName) => {
                this.addEventListener(eventName, (notifications, reason) => {
                    const status = ServiceMeta.STATUS_EVENT_MAP[eventName];
                    const notificationsMap = notifications.reduce((acc, n) => {
                        acc[n.timestamp] = n;
                        return acc;
                    }, {});
                    this.serviceHubAdapter.emit("statusServiceUpdateResponse", notificationsMap, status, reason);
                });
            });
        }
    }
    // public statics
    Service.sortTimestampsFn = (timestamp1, timestamp2) => {
        if (timestamp1 > timestamp2) {
            return 1;
        }
        if (timestamp1 < timestamp2) {
            return -1;
        }
        return 0;
    };
    Notifications.Service = Service;
})(Notifications || (Notifications = {}));
function createNotifications(config = {}) {
    const notifications = new Notifications.Service();
    notifications.updateConfig(config);
    return notifications;
}


/***/ }),

/***/ "./src/sdk.ts":
/*!********************!*\
  !*** ./src/sdk.ts ***!
  \********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   logger: () => (/* binding */ logger)
/* harmony export */ });
/* harmony import */ var _logger_Logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./logger/Logger */ "./src/logger/Logger.ts");

const objKeysToBeMasked = {
    title: true,
    text: true
};
const logger = (0,_logger_Logger__WEBPACK_IMPORTED_MODULE_0__.createLogger)("unified-ui-platform-sdk", objKeysToBeMasked);


/***/ }),

/***/ "./src/signal/signal.ts":
/*!******************************!*\
  !*** ./src/signal/signal.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Signal: () => (/* binding */ Signal)
/* harmony export */ });
var Signal;
(function (Signal) {
    class WithDataClass {
        constructor() {
            this.listeners = [];
            this.listenersOnce = [];
            this.listen = (listener) => {
                this.listeners.push(listener);
                return { stopListen: () => this.stopListen(listener) };
            };
            this.listenOnce = (listener) => {
                this.listenersOnce.push(listener);
                return { stopListenOnce: () => this.stopListenOnce(listener) };
            };
            this.stopListen = (listener) => {
                const index = this.listeners.indexOf(listener, 0);
                if (index > -1) {
                    this.listeners.splice(index, 1);
                    return true;
                }
                else {
                    return false;
                }
            };
            this.stopListenOnce = (listener) => {
                const index = this.listenersOnce.indexOf(listener, 0);
                if (index > -1) {
                    this.listenersOnce.splice(index, 1);
                    return true;
                }
                else {
                    return false;
                }
            };
            // concealed
            this.stopListenAll = () => {
                this.listeners = [];
                this.listenersOnce = [];
            };
            // concealed
            this.send = (data) => {
                this.listeners.forEach(listener => listener(data));
                this.listenersOnce.forEach(listener => listener(data));
                this.listenersOnce = [];
            };
        }
    }
    class EmptyClass {
        constructor() {
            this.listeners = [];
            this.listenersOnce = [];
            this.listen = (listener) => {
                this.listeners.push(listener);
                return { stopListen: () => this.stopListen(listener) };
            };
            this.listenOnce = (listener) => {
                this.listenersOnce.push(listener);
                return { stopListenOnce: () => this.stopListenOnce(listener) };
            };
            this.stopListen = (listener) => {
                const index = this.listeners.indexOf(listener, 0);
                if (index > -1) {
                    this.listeners.splice(index, 1);
                    return true;
                }
                else {
                    return false;
                }
            };
            this.stopListenOnce = (listener) => {
                const index = this.listenersOnce.indexOf(listener, 0);
                if (index > -1) {
                    this.listenersOnce.splice(index, 1);
                    return true;
                }
                else {
                    return false;
                }
            };
            // concealed
            this.stopListenAll = () => {
                this.listeners = [];
                this.listenersOnce = [];
            };
            // concealed
            this.send = () => {
                this.listeners.forEach(listener => listener());
                this.listenersOnce.forEach(listener => listener());
                this.listenersOnce = [];
            };
        }
    }
    class Create {
        withData() {
            const signal = new WithDataClass();
            return {
                signal,
                send: signal.send,
                stopListenAll: signal.stopListenAll
            };
        }
        empty() {
            const signal = new EmptyClass();
            return {
                signal,
                send: signal.send,
                stopListenAll: signal.stopListenAll
            };
        }
    }
    Signal.create = new Create();
})(Signal || (Signal = {}));


/***/ }),

/***/ "./src/timerWorker/helpers/Utils.ts":
/*!******************************************!*\
  !*** ./src/timerWorker/helpers/Utils.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createCache: () => (/* binding */ createCache),
/* harmony export */   createGenerateUniqueNumber: () => (/* binding */ createGenerateUniqueNumber),
/* harmony export */   isCallNotification: () => (/* binding */ isCallNotification),
/* harmony export */   isClearResponse: () => (/* binding */ isClearResponse)
/* harmony export */ });
const isClearResponse = (message) => {
    return message.error === null && typeof message.id === "number";
};
const isCallNotification = (message) => {
    return message.method !== undefined && message.method === "call";
};
const createCache = (lastNumberWeakMap) => {
    return (collection, nextNumber) => {
        lastNumberWeakMap.set(collection, nextNumber);
        return nextNumber;
    };
};
const MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER === undefined ? 9007199254740991 : Number.MAX_SAFE_INTEGER;
const TWO_TO_THE_POWER_OF_TWENTY_NINE = 536870912;
const TWO_TO_THE_POWER_OF_THIRTY = TWO_TO_THE_POWER_OF_TWENTY_NINE * 2;
const createGenerateUniqueNumber = (cache, lastNumberWeakMap) => {
    return (collection) => {
        const lastNumber = lastNumberWeakMap.get(collection);
        let nextNumber = lastNumber === undefined ? collection.size : lastNumber < TWO_TO_THE_POWER_OF_THIRTY ? lastNumber + 1 : 0;
        if (!collection.has(nextNumber)) {
            return cache(collection, nextNumber);
        }
        if (collection.size < TWO_TO_THE_POWER_OF_TWENTY_NINE) {
            while (collection.has(nextNumber)) {
                nextNumber = Math.floor(Math.random() * TWO_TO_THE_POWER_OF_THIRTY);
            }
            return cache(collection, nextNumber);
        }
        // Quickly check if there is a theoretical chance to generate a new number.
        if (collection.size > MAX_SAFE_INTEGER) {
            throw new Error("Congratulations, you created a collection of unique numbers which uses all available integers!");
        }
        // Otherwise use the full scale of safely usable integers.
        while (collection.has(nextNumber)) {
            nextNumber = Math.floor(Math.random() * MAX_SAFE_INTEGER);
        }
        return cache(collection, nextNumber);
    };
};


/***/ }),

/***/ "./src/timerWorker/index.ts":
/*!**********************************!*\
  !*** ./src/timerWorker/index.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   clearInterval: () => (/* binding */ clearInterval),
/* harmony export */   clearTimeout: () => (/* binding */ clearTimeout),
/* harmony export */   setInterval: () => (/* binding */ setInterval),
/* harmony export */   setTimeout: () => (/* binding */ setTimeout)
/* harmony export */ });
/* harmony import */ var _load_worker_timers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./load-worker-timers */ "./src/timerWorker/load-worker-timers.ts");
/* harmony import */ var _loadCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./loadCheck */ "./src/timerWorker/loadCheck.ts");
/* harmony import */ var _worker_min__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./worker-min */ "./src/timerWorker/worker-min.ts");



const loadWorkerTimers = (0,_load_worker_timers__WEBPACK_IMPORTED_MODULE_0__.createLoadWorkerTimers)(_loadCheck__WEBPACK_IMPORTED_MODULE_1__.load, _worker_min__WEBPACK_IMPORTED_MODULE_2__.worker); //returns workerTimers object containing the various timeout functions
const clearInterval = (timerId) => loadWorkerTimers().clearInterval(timerId);
const clearTimeout = (timerId) => loadWorkerTimers().clearTimeout(timerId);
const setInterval = (func, delay) => loadWorkerTimers().setInterval(func, delay);
const setTimeout = (func, delay) => loadWorkerTimers().setTimeout(func, delay);


/***/ }),

/***/ "./src/timerWorker/load-worker-timers.ts":
/*!***********************************************!*\
  !*** ./src/timerWorker/load-worker-timers.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createLoadWorkerTimers: () => (/* binding */ createLoadWorkerTimers)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");

let workerTimers = null;
const createLoadWorkerTimers = (load, worker) => {
    return () => {
        if (workerTimers !== null) {
            return workerTimers;
        }
        const blob = new Blob([worker], { type: "application/javascript; charset=utf-8" });
        const url = URL.createObjectURL(blob);
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info('Worker url established', url);
        workerTimers = load(url); //will return the custom timeout functions
        workerTimers.setTimeout(() => URL.revokeObjectURL(url), 0);
        return workerTimers;
    };
};


/***/ }),

/***/ "./src/timerWorker/loadCheck.ts":
/*!**************************************!*\
  !*** ./src/timerWorker/loadCheck.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   load: () => (/* binding */ load)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");
/* harmony import */ var _helpers_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers/Utils */ "./src/timerWorker/helpers/Utils.ts");


class TimerError extends Error {
    constructor() {
        super("The timer is in an undefined state.");
    }
}
const load = (url) => {
    // Prefilling the Maps with a function indexed by zero is necessary to be compliant with the specification.
    const scheduledIntervalFunctions = new Map([
        [
            0,
            () => {
                return;
            }
        ]
    ]); // tslint:disable-line no-empty
    const scheduledTimeoutFunctions = new Map([
        [
            0,
            () => {
                return;
            }
        ]
    ]); // tslint:disable-line no-empty
    const unrespondedRequests = new Map();
    const worker = new Worker(url);
    _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info("worker created ", worker);
    const LAST_NUMBER_WEAK_MAP = new WeakMap();
    const cache = (0,_helpers_Utils__WEBPACK_IMPORTED_MODULE_1__.createCache)(LAST_NUMBER_WEAK_MAP);
    const generateUniqueNumber = (0,_helpers_Utils__WEBPACK_IMPORTED_MODULE_1__.createGenerateUniqueNumber)(cache, LAST_NUMBER_WEAK_MAP);
    worker.addEventListener("message", ({ data }) => {
        if ((0,_helpers_Utils__WEBPACK_IMPORTED_MODULE_1__.isCallNotification)(data)) {
            const { params: { timerId, timerType } } = data;
            if (timerType === "interval") {
                const idOrFunc = scheduledIntervalFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    const timerIdAndTimerType = unrespondedRequests.get(idOrFunc);
                    if (timerIdAndTimerType === undefined ||
                        timerIdAndTimerType.timerId !== timerId ||
                        timerIdAndTimerType.timerType !== timerType) {
                        throw new TimerError();
                    }
                }
                else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                }
                else {
                    throw new TimerError();
                }
            }
            else if (timerType === "timeout") {
                const idOrFunc = scheduledTimeoutFunctions.get(timerId);
                if (typeof idOrFunc === "number") {
                    const timerIdAndTimerType = unrespondedRequests.get(idOrFunc);
                    if (timerIdAndTimerType === undefined ||
                        timerIdAndTimerType.timerId !== timerId ||
                        timerIdAndTimerType.timerType !== timerType) {
                        throw new TimerError();
                    }
                }
                else if (typeof idOrFunc !== "undefined") {
                    idOrFunc();
                    // A timeout can be savely deleted because it is only called once.
                    scheduledTimeoutFunctions.delete(timerId);
                }
                else {
                    throw new TimerError();
                }
            }
        }
        else if ((0,_helpers_Utils__WEBPACK_IMPORTED_MODULE_1__.isClearResponse)(data)) {
            const { id } = data;
            const timerIdAndTimerType = unrespondedRequests.get(id);
            if (timerIdAndTimerType === undefined) {
                throw new TimerError();
            }
            const { timerId, timerType } = timerIdAndTimerType;
            unrespondedRequests.delete(id);
            if (timerType === "interval") {
                scheduledIntervalFunctions.delete(timerId);
            }
            else {
                scheduledTimeoutFunctions.delete(timerId);
            }
        }
        else {
            const { error: { message } } = data;
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error(message);
        }
    });
    const clearInterval = (timerId) => {
        const id = generateUniqueNumber(unrespondedRequests);
        unrespondedRequests.set(id, { timerId, timerType: "interval" });
        scheduledIntervalFunctions.set(timerId, id);
        worker.postMessage({
            id,
            method: "clear",
            params: { timerId, timerType: "interval" }
        });
    };
    const clearTimeout = (timerId) => {
        const id = generateUniqueNumber(unrespondedRequests);
        unrespondedRequests.set(id, { timerId, timerType: "timeout" });
        scheduledTimeoutFunctions.set(timerId, id);
        worker.postMessage({
            id,
            method: "clear",
            params: { timerId, timerType: "timeout" }
        });
    };
    const setInterval = (func, delay) => {
        const timerId = generateUniqueNumber(scheduledIntervalFunctions);
        scheduledIntervalFunctions.set(timerId, () => {
            func();
            // Doublecheck if the interval should still be rescheduled because it could have been cleared inside of func().
            if (typeof scheduledIntervalFunctions.get(timerId) === "function") {
                worker.postMessage({
                    id: null,
                    method: "set",
                    params: {
                        delay,
                        now: performance.now(),
                        timerId,
                        timerType: "interval"
                    }
                });
            }
        });
        worker.postMessage({
            id: null,
            method: "set",
            params: {
                delay,
                now: performance.now(),
                timerId,
                timerType: "interval"
            }
        });
        return timerId;
    };
    const setTimeout = (func, delay) => {
        const timerId = generateUniqueNumber(scheduledTimeoutFunctions);
        scheduledTimeoutFunctions.set(timerId, func);
        worker.postMessage({
            id: null,
            method: "set",
            params: {
                delay,
                now: performance.now(),
                timerId,
                timerType: "timeout"
            }
        });
        return timerId;
    };
    return {
        clearInterval,
        clearTimeout,
        setInterval,
        setTimeout
    };
};


/***/ }),

/***/ "./src/timerWorker/worker-min.ts":
/*!***************************************!*\
  !*** ./src/timerWorker/worker-min.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   worker: () => (/* binding */ worker)
/* harmony export */ });
// This is the minified and stringified code of the worker-timers-worker package.
// tslint:disable-line:max-line-length
const worker = `(()=>{"use strict";
const e=new Map,t=new Map,r=(e,t)=>
{let r,o;const i=performance.now();r=i,o=e-Math.max(0,i-t);
    return{expected:r+o,remainingDelay:o}},
    o=(e,t,r,i)=>{const s=performance.now();
        s>r?postMessage({id:null,method:"call",params:{timerId:t,timerType:i}}):e.set(t,setTimeout(o,r-s,e,t,r,i))};
        addEventListener("message",(i=>{let{data:s}=i;try{if("clear"===s.method){const{id:r,params:{timerId:o,timerType:i}}=s;
        if("interval"===i)
        (t=>{const r=e.get(t);
        if(void 0===r)
        throw new Error('There is no interval scheduled with the given id "'.concat(t,'".'));
        clearTimeout(r),e.delete(t)})(o),postMessage({error:null,id:r});
        else{if("timeout"!==i)
        throw new Error('The given type "'.concat(i,'" is not supported'));
        (e=>{const r=t.get(e);if(void 0===r)
        throw new Error('There is no timeout scheduled with the given id "'.concat(e,'".'));
        clearTimeout(r),t.delete(e)})(o),postMessage({error:null,id:r})}}
        else{if("set"!==s.method)
        throw new Error('The given method "'.concat(s.method,'" is not supported'));
        {const{params:{delay:i,now:n,timerId:a,timerType:d}}=s;
        if("interval"===d)
        ((t,i,s)=>{const{expected:n,remainingDelay:a}=r(t,s);
        e.set(i,setTimeout(o,a,e,i,n,"interval"))})(i,a,n);
        else{if("timeout"!==d)
        throw new Error('The given type "'.concat(d,'" is not supported'));
        ((e,i,s)=>{const{expected:n,remainingDelay:a}=r(e,s);
        t.set(i,setTimeout(o,a,t,i,n,"timeout"))})(i,a,n)}}}}catch(e){postMessage({error:{message:e.message},id:s.id,result:null})}}))})();`;


/***/ }),

/***/ "./src/utils/assertUtils.ts":
/*!**********************************!*\
  !*** ./src/utils/assertUtils.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AssertUtils: () => (/* binding */ AssertUtils)
/* harmony export */ });
/* harmony import */ var _sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../sdk */ "./src/sdk.ts");

var AssertUtils;
(function (AssertUtils) {
    let errorHandler = null;
    // Method to inject the error handling function
    function setErrorHandler(handler) {
        if (errorHandler) {
            _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.error("Error handler already set");
            return;
        }
        _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`Setting custom error handler: ${handler}`);
        errorHandler = handler;
    }
    AssertUtils.setErrorHandler = setErrorHandler;
    function check(condition, functionName, message) {
        if (!condition) {
            if (errorHandler) {
                errorHandler(functionName, message);
            }
            else {
                _sdk__WEBPACK_IMPORTED_MODULE_0__.logger.info(`Assert failed in ${functionName}: ${message}`);
            }
        }
        return condition;
    }
    AssertUtils.check = check;
})(AssertUtils || (AssertUtils = {}));


/***/ }),

/***/ "./src/utils/errorHandling.ts":
/*!************************************!*\
  !*** ./src/utils/errorHandling.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ensureError: () => (/* binding */ ensureError)
/* harmony export */ });
/**
 * Transforms any value into an Error. Can be used to ensure that a value is an Error
 * inside a catch block.
 * @param value
 * @returns
 */
function ensureError(value) {
    // https://medium.com/with-orus/the-5-commandments-of-clean-error-handling-in-typescript-93a9cbdf1af5
    if (value instanceof Error) {
        return value;
    }
    let stringified = "[Unable to stringify the thrown value]";
    try {
        stringified = JSON.stringify(value);
    }
    catch (_a) {
        /* empty */
    }
    return new Error(`This value was thrown as is, not through an Error: ${stringified}`);
}


/***/ }),

/***/ "axios":
/*!************************!*\
  !*** external "axios" ***!
  \************************/
/***/ ((module) => {

module.exports = require("axios");

/***/ }),

/***/ "event-emitter":
/*!********************************!*\
  !*** external "event-emitter" ***!
  \********************************/
/***/ ((module) => {

module.exports = require("event-emitter");

/***/ }),

/***/ "event-emitter/all-off":
/*!****************************************!*\
  !*** external "event-emitter/all-off" ***!
  \****************************************/
/***/ ((module) => {

module.exports = require("event-emitter/all-off");

/***/ }),

/***/ "i18next":
/*!**************************!*\
  !*** external "i18next" ***!
  \**************************/
/***/ ((module) => {

module.exports = require("i18next");

/***/ }),

/***/ "i18next-browser-languagedetector":
/*!***************************************************!*\
  !*** external "i18next-browser-languagedetector" ***!
  \***************************************************/
/***/ ((module) => {

module.exports = require("i18next-browser-languagedetector");

/***/ }),

/***/ "i18next-http-backend":
/*!***************************************!*\
  !*** external "i18next-http-backend" ***!
  \***************************************/
/***/ ((module) => {

module.exports = require("i18next-http-backend");

/***/ }),

/***/ "luxon":
/*!************************!*\
  !*** external "luxon" ***!
  \************************/
/***/ ((module) => {

module.exports = require("luxon");

/***/ }),

/***/ "uuid":
/*!***********************!*\
  !*** external "uuid" ***!
  \***********************/
/***/ ((module) => {

module.exports = require("uuid");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__("./src/index.ts");
/******/ 	
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map